/**
 * @file 将 object 的数据序列化为 string
 * @author FengGuang(fengguang01@baidu.com)
 */

// 将 obj 的数据对象的 key 排序后再进行序列化
// 可以将对象作为某些组件的 key 使用
export default function getSortParams(init?: string[][] | Record<string, string | undefined> | string | URLSearchParams): string {
    let initParam;
    if (!Array.isArray(init) && typeof (init) === 'object' && !(init instanceof URLSearchParams)) {
        const tmpint: Record<string, string> = {};
        Object.entries(init).forEach(([key, value]) => {
            if (typeof (value) === 'string') {
                tmpint[key] = value;
            }
        });
        initParam = tmpint;
    }
    else {
        initParam = init;
    }
    const params = new URLSearchParams(initParam);
    params.sort();
    return params.toString();
};
